module.exports = __webpack_public_path__ + "media/images/emblems/Wangen_bO-blason-426a5324833ba6c69acbf94adc83db8c.png";